<!--  -->
<template>
  <div class="Profile">
    <div class="Profile_main">
      <h1>{{ Profile_title }}</h1>
      <div class="Profile_text">
        <div class="Profile_video">
          <!-- <video-player
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
          ></video-player> -->
          <img src="../../assets/choose/chooseVideo.png" />
        </div>
        <!-- <h2>{{ Profile_title2 }}</h2> -->
        <p>{{ Profile_content }}</p>
        <span>{{ Profile_content2 }}</span>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      Profile_title: "",
      Profile_title2: "",
      Profile_content: "",
      Profile_content2: "",

      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "", //url地址
          },
        ],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    var that = this;
    $.ajax({
      url: "/index.php?s=Home/Api/get_data",
      type: "get",
      datatype: "json",
      data: {
        act: "article_list",
        category_id: 15,
        show_num: 1,
      },
      success: function (ret) {
        var obj = JSON.parse(ret); //json数据转为数组
        if (obj.code == "0000") {
          that.Profile_title = obj.yj_name;
          that.Profile_title2 = obj.data[0].title;
          var linshi = obj.data[0].msgs.split("<br />");
          that.Profile_content = linshi[0];
          that.Profile_content2 = linshi[1];
          that.playerOptions.sources[0].src = obj.data[0].filepath;
          console.log(that.playerOptions.sources[0].src);
        }
      },
      error: function (err) {
        console.log("ajax错误");
      },
    });
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../scss/public.scss";
.Profile {
  width: 100%;
  .Profile_main {
    width: 100%;
    padding: 110px 9.25rem;
    h1 {
      text-align: center;
      font-size: 2rem;
      font-weight: bold;
      color: #39404a;
    }
    .Profile_text {
      margin-top: 90px;
      .Profile_video {
        width: 60%;
        float: left;
        margin-right: 70px;
        margin-bottom: 50px;
        z-index: 999;
        img {
          width: 100%;
        }
      }
      h2 {
        padding-top: 20px;
        font-size: 1.8rem;
        font-weight: bold;
        color: #39404a;
      }
      p {
        font-size: 1rem;
        font-weight: 400;
        color: #39404a;
        line-height: 1.8;
        opacity: 0.8;
        margin-top: 40px;
        pointer-events: none;
      }
      span {
        display: inline-block;
        margin-top: 10px;
        font-size: 1rem;
        font-weight: 400;
        color: #39404a;
        line-height: 1.8;
        opacity: 0.8;
      }
    }
  }
}
@media screen and (max-width: 1600px) {
  .Profile {
    width: 100%;
    .Profile_main {
      width: 100%;
      padding: 110px 6rem;
      .Profile_text {
        margin-top: 90px;
        .Profile_video {
          float: left;
          margin-right: 40px;
          margin-bottom: 20px;
          z-index: 999;
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .Profile {
    .Profile_main {
      padding: 20px 10px;
      h1 {
        font-size: 1.8rem;
      }
      h2 {
        font-size: 1.8rem;
      }
      .Profile_text {
        margin-top: 30px;
        img {
          width: 100%;
        }
        span {
          width: 100%;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/AboutUs/Profile.vue